"use strict";

$(function () {
    // Sauvegarde puis rétablissement du tab choisi
    $(".nav-link").on("click", function () {
        document.location.hash = this.hash || $(this).data("tab-name");
    });
    if (document.location.hash) {
        $("a[href='" + document.location.hash + "'], a[data-tab-name='" + document.location.hash + "']:not([data-url])").trigger("click");
    }
    // Vidage de la modal à la fermeture
    $("#modal").on("hidden.bs.modal", function () {
        var $this = $(this);
        $this.find(".modal-title").text("");
        $this.find(".modal-body").html("<div class=\"text-center\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw margin-bottom\"></i></div>");
        $this.find(".modal-footer a").show();
    });
});
//Exécution de l'évaluation paramétrée pour la demande de confirmation dans la modale
var transEvaluator = function transEvaluator(el, eva, val) {
    var $el = $(el);
    if (eva === "=") {
        return $el.val() === val;
    }
    //TODO implémenter d'autre possibilités
    return false;
};
//Cas de confirmation dans la modale
var confirmInModale = function confirmInModale($btn) {
    var message = $btn.data("confirm-message");
    if (message !== null && message !== undefined && message !== "") {
        var condition = $btn.data("confirm-condition");
        if (condition !== null && condition !== undefined && condition !== "") {
            var splitCondition = condition.split("|");
            if (splitCondition.length >= 3) {
                var ctrlId = splitCondition[0],
                    evaluator = splitCondition[1],
                    attendu = splitCondition[2];
                if (transEvaluator(ctrlId, evaluator, attendu) && !confirm(message.replace(/\s?\\n\s?/gim, "\n"))) {
                    return false;
                }
            }
        } else if (!confirm(message)) {
            return false;
        }
    }
    return true;
};
//Méthode d'initialisation des controles d'une modale
var initControlInModal = function initControlInModal($target) {
    $target.codeMirror();
    $target.find(".select2").select2({
        width: "100%"
    });
    $.each($target.find(".datetimepicker"), function (i, el) {
        $(el).initDateTimePicker();
    });
};
// Vidage de la modal à la fermeture
$("#modal").on("hidden.bs.modal", function () {
    var $this = $(this);
    $this.find(".modal-title").text("");
    $this.find(".modal-body").html("<div class=\"text-center\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw margin-bottom\"></i></div>");
    $this.find(".modal-footer").find("> a").show();
});
// Evenement du submit done
$.fn.afterSubmitEvent = function (e, data) {
    var $this = $(this),
        onDone = $this.data("onDone");
    switch (onDone) {
        case "reload":
            document.location.reload();
            break;
        default:
            $("body").trigger(onDone, [data]);
    }
};
// Affichage d'une modale lors du clic sur un bouton d'ouverture de modale
$("body").on("click", 'button[data-toggle="modal"]', function (e) {
    e.preventDefault();
    var $me = $(this),
        $target = $($me.data("target")),
        $body = $target.find(".modal-body"),
        $title = $target.find(".modal-title"),
        $form = $me.parents("form");
    if ($form.length) {
        $title.text($me.data("title"));
        var modalBody = $me.data("modal-body");
        if ($body[modalBody]) {
            $body[modalBody]($me);
        } else {
            $body.html(modalBody);
        }
        var $btn = $target.find(".btn-success");
        if ($me.parents(".modal").length > 0) {
            $target.css("z-index", 1051);
        }
        $btn.off().on("click", function () {
            var formaction = $me.attr("formaction");
            if (formaction) {
                $form.attr("action", formaction);
            }
            if (confirmInModale($me)) {
                $btn.off();
                if ($me.data("submitAjax")) {
                    $form.submitAjax();
                } else {
                    $form.submit();
                }
            }
            return true;
        });
        $form.on("form.submit.done", function (e, data) {
            $me.afterSubmitEvent(e, data);
        });
    }
});
// Modale Ajax
$("body").on("click", 'a[data-toggle="modal"][href]', function (e) {
    e.preventDefault();
    var $me = $(this),
        href = $me.attr("href"),
        $target = $($me.data("target")),
        size = $me.data("size"),
        hideOkButton = $me.data("hide-ok-btn"),
        $body = $target.find(".modal-body"),
        $title = $target.find(".modal-title"),
        $dialog = $target.find(".modal-dialog"),
        $btnOk = $target.find(".modal-footer a.btn-success"),
        spinnerOnSubmit = JSON.parse($me.data("spinner-on-submit") || false);
    $title.text($me.data("title"));
    if (hideOkButton) {
        $btnOk.hide();
    }
    var sizeMap = {
        l: "modal-lg",
        xl: "modal-xlg"
    };
    $dialog.attr("class", "modal-dialog " + (sizeMap[size] || ""));
    if ($me.parents(".modal").length > 0) {
        $target.css("z-index", 1051);
    }
    $body.load(href, function () {
        $target.trigger("modal.loaded", {
            source: $me,
            body: $body,
            title: $title
        });
        initControlInModal($target);
        var callbackInit = $me.data("init-callback");
        if (callbackInit) {
            $target[callbackInit]();
        }
        if ($me.data("unobtrusive-validation")) {
            $.validator.unobtrusive.parse($target);
        }
        var $btn = $target.find(".btn-success");
        $btn.off().on("click", function () {
            var $form = $target.find("form");
            if (!$form.valid() || $me.data("submit-callback") && !$target[$me.data("submit-callback")]()) {
                return false;
            }
            var formaction = $me.attr("formaction");
            if (formaction) {
                $form.attr("action", formaction);
            }
            if (confirmInModale($me)) {
                $btn.off();
                if (spinnerOnSubmit) {
                    $target.find(".modal-content ").append("<div class=\"spinner-on-modal\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw margin-bottom\"></i></div>");
                }
                if ($me.data("just-submit")) {
                    $form.submit();
                } else {
                    $form.submitAjax();
                }
            }
        });
        var $newTitle = $target.find(".replace-modal-title");
        if ($newTitle.length > 0) {
            $title.html($newTitle.html());
            $newTitle.remove();
        }
    });
    $target.on("form.submit.done", function (e, data) {
        $me.afterSubmitEvent(e, data);
    });
});
/**
 * Chargement Ajax des liens qui s'ouvrent dans une target (les tabs, les pills, etc)
 */
$("body").on("shown.bs.tab", "a[data-toggle][data-target][href]:not([href^='#'])", function (e) {
    var $link = $(e.currentTarget);
    var $target = $($link.data("target"));
    var href = $link.attr("href");
    var callback = $link.data("callback");
    var callbackJquery = $link.data("callback-jquery");
    $target.load(href, function () {
        if ($link.data("unobstrusive-validation") !== false) {
            $.validator.unobtrusive.parse($target.find("form"));
        }
        if (callback) {
            $target[callback]();
        }
        if (callbackJquery) {
            $[callbackJquery]();
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Addons/bootstrap-addons.ts
// module id = 514
// module chunks = 0